import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { PropertyFilterAmenity } from '__generated__/api';

export const getAmenitiesInput = (searchCriteria: SearchCriteriaModel): PropertyFilterAmenity[] | null => {
  if (searchCriteria.amenities && searchCriteria.amenities.length > 0) {
    return searchCriteria.amenities
      .map(amen => {
        const result = PropertyFilterAmenity[PropertyFilterAmenity[amen]];

        return result ? result : null;
      })
      .filter(x => x !== null);
  }

  return null;
};
